import { isProduction } from '@/config/constants'

type Field = {
  label: string
  value: string
  valueColor?: string
}
type MessageType = 'error' | 'warning'

const formatTimeStr = (stamp: Date, format = 'Y-M-D') => {
  let date = null;
  if (stamp === null) {
    date = new Date();
  } else if (typeof stamp === 'object') {
    date = stamp;
  } else {
    date = new Date(parseInt(stamp))
  }

  function prependZero(part: number) {
    return ('0' + String(part)).substr(-2)
  }

  let parts = {
    Y: date.getFullYear().toString(),
    y: date.getFullYear().toString().substr(-2),
    M: prependZero(date.getMonth() + 1),
    m: (date.getMonth() + 1).toString(),
    D: prependZero(date.getDate()),
    d: date.getDate().toString(),
    H: prependZero(date.getHours()),
    I: prependZero(date.getMinutes()),
    S: prependZero(date.getSeconds())
  }

  return format.replace(/[YyMmDdHIS]/g, match => {
    return parts[match]
  })
}
const getAppName = () => {
  const currentPath = location.href
  const apps = [
    {
      name: 'Video Enhancer',
      path: '/video/enhance-video-online'
    },
    {
      name: 'Vocal Remover',
      path: '/video/vocal-remover'
    },
    {
      name: 'Video Generator',
      path: '/video/video-generator'
    }
  ]
  let name = '未知应用'
  for (let i = 0; i < apps.length; i++) {
    let item = apps[i]
    if (currentPath.indexOf(item.path) !== -1) {
      name = item.name
      break
    }
  }

  return name
}
const parseSourceMap = async (filename: string, lineNo: number, colNo: number) => {
  return new Promise(async (resolve) => {
    let mapFile = await (await fetch(filename)).json()
    // @ts-ignore
    if (!sourceMap) return
    // @ts-ignore
    await sourceMap.SourceMapConsumer.with(mapFile, null, consumer => {
      let res = consumer.originalPositionFor({
        line: lineNo,
        column: colNo
      })
      resolve(res)
    })
  })
}

const reportError = (reason: string, info: any) => {
  let fields: Field[] = [
    {
      label: '触发环境',
      value: isProduction ? '生产' : '开发或测试',
      valueColor: isProduction ? 'green' : 'gray'
    },
    {
      label: '错误消息',
      value: reason,
      valueColor: 'red'
    },
  ]
  if (info.source !== null) {
    fields.push({
      label: '出错文件',
      value: info.source.replace(/\.\.\//g, '')
    })
  }
  if (info.name !== null) {
    fields.push({
      label: '相关上下文',
      value: info.name
    })
  }
  fields.push({
    label: '行数',
    value: info.line
  })
  fields.push({
    label: '列数',
    value: info.column
  })
  fields.push({
    label: '发生时间',
    value: formatTimeStr(new Date(), 'Y-M-D H:I:S')
  })

  let message: string = buildMessage(fields)
  fetch('https://api.hitpaw.com/api/frontend-alarm', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: 'msg=' + message
  }).then(async (res) => {
    let result = await res.json()
    console.log(result)
  })
}

export const reportCustomError = (reason: string, fieldList: Field[], messageType?: MessageType) => {
  let fields: Field[] = [
    {
      label: '触发环境',
      value: isProduction ? '生产' : '开发或测试',
      valueColor: isProduction ? 'green' : 'gray'
    },
    {
      label: '错误消息',
      value: reason,
      valueColor: isProduction ? (messageType === 'warning' ? '#DE8E47' : 'red') : 'gray'
    }
  ]

  fields = fields.concat(fieldList)
  fields.push({
    label: '发生时间',
    value: formatTimeStr(new Date(), 'Y-M-D H:I:S')
  })

  let message: string = buildMessage(fields)
  fetch('https://api.hitpaw.com/api/frontend-alarm', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: 'msg=' + encodeURIComponent(message)
  }).then(async (res) => {
    let result = await res.json()
    console.log(result)
  })
}

const buildMessage = (fields: Field[]) => {
  let name = getAppName()
  let message = `【<font color="green">${name}</font>】异常报警信息\n`
  fields.forEach(item => {
    if (item.valueColor !== undefined) {
      message += `${item.label}: <font color="${item.valueColor}">${item.value}</font>\n`
    } else {
      message += `${item.label}: <font color="gray">${item.value}</font>\n`
    }
  })
  return message
}

export const handleError = (stack: string) => {
  let lines = stack.split('\n')
  let reason = lines[0].trim()
  let res = lines[1].match(/^.*\((.*):(\d+):(\d+)\)$/)
  if (res) {
    let file = res[1]
    let lineNo = res[2]
    let colNo = res[3]

    let filename = file.split('/').pop()
    parseSourceMap(`/video/maps/${filename}.map`, Number(lineNo), Number(colNo)).then(res => {
      reportError(reason, res)
    })
  }
}